import React, { createContext, useState, useContext } from "react";
import { AnimatePresence, motion } from "framer-motion";

const ConfirmContext = createContext();

export const useConfirm = () => useContext(ConfirmContext);

export const ConfirmProvider = ({ children }) => {
  const [confirmData, setConfirmData] = useState(null);

  const requestConfirm = (message, onConfirm) => {
    setConfirmData({ message, onConfirm });
  };

  const handleConfirm = () => {
    confirmData.onConfirm?.();
    setConfirmData(null);
  };

  const handleCancel = () => setConfirmData(null);

  return (
    <ConfirmContext.Provider value={{ requestConfirm }}>
      {children}

      <AnimatePresence>
        {confirmData && (
          <motion.div
            className="fixed inset-0 z-[999] flex items-center justify-center bg-black/50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.15, ease: "easeOut" }}
            onClick={handleCancel}
          >
            
            <motion.div
              className="bg-white rounded-lg shadow-xl w-[90%] max-w-sm p-6"
              initial={{ scale: 0.98, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ duration: 0.15, ease: "easeOut", }}
            >
              <h3 className="text-lg font-semibold text-gray-800 mb-2">Potwierdzenie</h3>
              <p className="text-sm text-gray-600 mb-6">{confirmData.message}</p>
              <div className="flex justify-end gap-2">
                <button
                  onClick={handleCancel}
                  className="px-4 py-2 text-sm rounded border border-gray-300 hover:bg-gray-100"
                >
                  Anuluj
                </button>
                <button
                  onClick={handleConfirm}
                  className="px-4 py-2 text-sm rounded bg-[#ad160e] text-white hover:bg-[#8c100b]"
                >
                  Potwierdź
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </ConfirmContext.Provider>
  );
};
